<div class="upload-wrapper">
  <mat-card class="file-preview" appearance="outlined">
    <div
      draggable="true"
      ngClass="{{ dragAreaClass }}"
      (click)="triggerFileInput()"
    >
      <div class="col-md-12 text-center drag-file-text">
        Drag image/video files here or click to upload <br /><span
          class="drag-file-text__size"
          >(Maximum attachment size <strong>15MB</strong> for images and
          <strong>100MB</strong> for videos)</span
        >
        <input
          #fileInput
          type="file"
          accept="image/*,video/*,.heic,.jfif"
          (change)="onFileSelected($event)"
          hidden
          multiple
        />
      </div>
      <input
        type="file"
        #file
        [multiple]="false"
        (change)="onFileSelected($event)"
        style="display: none"
      />
    </div>
    
    <div *ngIf="uploadedFiles.length > 0" class="preview-container">
      <div class="preview-item" *ngFor="let file of uploadedFiles; let i = index">
        <img
          *ngIf="file.file_display && file.type.startsWith('image/')"
          [src]="file.file_display"
          class="image-preview"
          alt="Image preview"
        />

        <div
          class="video-wrapper"
          *ngIf="file.file_display && file.type.startsWith('video/')"
        >
          <video [src]="file.file_display" class="image-preview" controls></video>

          <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-dots">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu" class="custom-menu">
            <button mat-menu-item (click)="playVideo(file)">
              <mat-icon>play_arrow</mat-icon> Play
            </button>
            <button mat-menu-item (click)="fullscreenVideo(file)">
              <mat-icon>fullscreen</mat-icon> Fullscreen
            </button>
            <button mat-menu-item (click)="downloadFile(file)">
              <mat-icon>download</mat-icon> Download
            </button>
            <button mat-menu-item (click)="changePlaybackSpeed(file)">
              <mat-icon>speed</mat-icon> Playback speed
            </button>
            <button mat-menu-item (click)="pictureInPicture(file)">
              <mat-icon>picture_in_picture_alt</mat-icon> Picture in picture
            </button>
          </mat-menu>
        </div>

        <div class="image-info">
          #{{ i + 1 }}
          {{
            file.type.startsWith("image/")
              ? "Image"
              : file.type.startsWith("video/")
              ? "Video"
              : "File"
          }}
          <mat-icon class="remove-file" (click)="RemoveFile(file)">
            cancel
          </mat-icon>
        </div>

        <div *ngIf="file.uploading" class="uploading-indicator">
          <mat-progress-spinner 
            diameter="30" 
            strokeWidth="3"
            mode="indeterminate"
            class="centered-spinner">
          </mat-progress-spinner>
        </div>
      </div>
    </div>

    <div class="preview-actions">
      <button
        mat-raised-button
        (click)="confirmUpload()"
        *ngIf="uploadedFiles.length > 0"
        [ngStyle]="{
          'background-color': configs?.colors?.bot_message_button_background,
          color: configs?.colors?.bot_message_text,
          border: '1px solid ' + configs?.colors?.bot_message_border
        }"
        class="btn-done"
      >
        Done
      </button>
      <button
        mat-raised-button
        (click)="cancelOperation()"
        [ngStyle]="{
          'background-color': configs?.colors?.bot_message_button_background,
          color: configs?.colors?.bot_message_text,
          border: '1px solid ' + configs?.colors?.bot_message_border
        }"
        class="btn-cancel"
      >
        Cancel
      </button>
    </div>
  </mat-card>
  <app-alert-popup
    *ngIf="showAlert"
    [message]="alertInfo.message"
    (onClose)="closeAlert()"
  >
  </app-alert-popup>
</div>